/**
 * Format a UTC appointment instant in the viewer's time zone.
 * Pass timeZone only when the caller needs a specific zone, such as a test.
 */
export function formatAppointmentWhen(iso: string, timeZone?: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) {
    return iso
  }

  return new Intl.DateTimeFormat(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
    ...(timeZone ? { timeZone } : {}),
  }).format(date)
}

/** Convert a UTC ISO instant to a datetime-local value in the viewer zone. */
export function utcIsoToDateTimeLocal(iso: string): string {
  const date = new Date(iso)
  const pad = (value: number) => String(value).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

/** Convert a datetime-local value, which is viewer-local, to a UTC ISO instant. */
export function dateTimeLocalToUtcIso(value: string): string {
  return new Date(value).toISOString()
}

export function startOfWeek(date: Date): Date {
  const copy = new Date(date)
  copy.setHours(0, 0, 0, 0)
  const day = copy.getDay()
  const mondayOffset = day === 0 ? -6 : 1 - day
  copy.setDate(copy.getDate() + mondayOffset)
  return copy
}

export function addDays(date: Date, days: number): Date {
  const copy = new Date(date)
  copy.setDate(copy.getDate() + days)
  return copy
}

/** datetime-local value for a clock time on the viewer's calendar day. */
export function dateTimeLocalOn(day: Date, hours: number, minutes: number): string {
  const copy = new Date(day.getFullYear(), day.getMonth(), day.getDate(), hours, minutes, 0, 0)
  const pad = (value: number) => String(value).padStart(2, '0')
  return `${copy.getFullYear()}-${pad(copy.getMonth() + 1)}-${pad(copy.getDate())}T${pad(copy.getHours())}:${pad(copy.getMinutes())}`
}
